import { motion } from "framer-motion";

export const SocialLink = ({ href, label, testId, brand, children, isMail = false }) => {
  const props = isMail
    ? { href }
    : { href, target: "_blank", rel: "noopener noreferrer" };

  return (
    <motion.a
      whileHover={{ y: -4, scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      {...props}
      style={brand ? { "--brand": brand } : undefined}
      className="social-brand w-12 h-12 bg-[hsl(var(--primary))]/10 border border-[hsl(var(--primary))]/20 rounded-lg flex items-center justify-center font-mono text-xs font-bold text-[hsl(var(--primary))]"
      data-testid={testId}
      aria-label={label}
    >
      {children}
    </motion.a>
  );
};
